"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CellType = void 0;
let CellType = exports.CellType = /*#__PURE__*/function (CellType) {
  CellType["Boolean"] = "b";
  CellType["Date"] = "d";
  CellType["Empty"] = "z";
  CellType["Error"] = "e";
  CellType["Number"] = "n";
  CellType["String"] = "s";
  CellType["Unknown"] = "u";
  return CellType;
}({});